export default {
  state: {
    id: undefined,
    name: undefined,
    description: undefined,
    slug: undefined,
    tagType: undefined,
    visible: undefined,
    created_at: undefined,
    updated_at: undefined
  }
}



// WEBPACK FOOTER //
// ./src/stores/TagStore.js